import { render, staticRenderFns } from "./institutional-page.vue?vue&type=template&id=9cabf5d6&scoped=true"
import script from "./institutional-page.vue?vue&type=script&lang=js"
export * from "./institutional-page.vue?vue&type=script&lang=js"
import style0 from "./institutional-page.vue?vue&type=style&index=0&id=9cabf5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cabf5d6",
  null
  
)

export default component.exports